import { API } from "../auth/authApi";

// GET PRODUCTS
export const getCompanyProductsApi = (params) => {
  return API.get("/company-product", { params });
};

// CREATE PRODUCT
export const createCompanyProductApi = (data) => {
  return API.post("/company-product", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// UPDATE PRODUCT
export const updateCompanyProductApi = (id, data) => {
  return API.put(`/company-product/${id}`, data);
};

// DELETE PRODUCT
export const deleteCompanyProductApi = (id) => {
  return API.delete(`/company-product/${id}`);
};